import { useState } from "react";
import styles from "../styles/GetAppLanding.module.scss";
import { faqs } from "./landingData";

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(-1);

  return (
    <section className={styles.faqSection}>
      <div className={styles.faqInner}>
        <h2>Frequently Asked Questions</h2>
        <div className={styles.faqList}>
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <article
                className={`${styles.faqItem} ${isOpen ? styles.faqItemOpen : ""}`}
                key={item.question}
              >
                <button
                  aria-controls={`getapp-faq-answer-${index}`}
                  aria-expanded={isOpen}
                  id={`getapp-faq-question-${index}`}
                  onClick={() =>
                    setOpenIndex((currentIndex) =>
                      currentIndex === index ? -1 : index,
                    )
                  }
                  type="button"
                >
                  {item.question}
                  <span className={styles.faqChevron} aria-hidden="true" />
                </button>
                <div
                  aria-labelledby={`getapp-faq-question-${index}`}
                  aria-hidden={!isOpen}
                  className={styles.faqAnswerWrap}
                  id={`getapp-faq-answer-${index}`}
                  role="region"
                >
                  <p>{item.answer}</p>
                </div>
              </article>
            );
          })}
          <a
            className={styles.faqShowAllLink}
            href="https://blogs.joinabound.com/faq/"
            rel="noreferrer"
            target="_blank"
          >
            <span>Show all</span>
            <span className={styles.faqShowAllArrow} aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
